import meta from './zh/meta';
import layout from './zh/layout';
import home from './zh/home';
import membersPage from './zh/membersPage';
import publicationsPage from './zh/publicationsPage';
import teachingPage from './zh/teachingPage';
import openingPage from './zh/openingPage';
import notFound from './zh/notFoundPage';
import router from './zh/router';

export default {
  meta,
  layout,
  home,
  membersPage,
  publicationsPage,
  teachingPage,
  openingPage,
  notFound,
  router,
};
